"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(theme, props, state) {
  var palette = theme.palette;
  return {
    root: {
      top: 0,
      left: 0,
      zIndex: theme.overlayZIndex,
      minHeight: '100vh',
      width: '100%',
      // IOS < 11.3 не ресайзит viewport при открытии виртуальной клавиатуры, из-за чего
      // ломается расположение элементов на странице
      position: state.isIOS ? 'absolute' : 'fixed',
      overflowY: 'auto',
      zoom: 1,
      height: '100vh',
      '&:after': {
        clear: 'both',
        content: '""',
        display: 'block',
        height: 0
      }
    },
    overlay: {
      width: "calc(100% - ".concat(state.scrollWidth, "px)"),
      height: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: theme.overlayBackground,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    container: {
      background: theme.background,
      borderRadius: theme.borderRadius,
      boxShadow: theme.boxShadow,
      overflow: theme.overflow,
      position: 'relative',
      display: 'flex'
    },
    wrapper: {
      position: 'absolute',
      top: 0,
      left: 0,
      transform: 'translateY(calc(50vh - 150px)) translateX(calc(50% - 150px))',
      transition: "transform 150ms ".concat(palette.transitionFunction, ", opacity 150ms ").concat(palette.transitionFunction),
      opacity: 0
    },
    closeIcon: {
      position: 'absolute',
      top: palette.gutter * 4 + 'px',
      right: palette.gutter * 4 + 'px'
    }
  };
}